import {
  Component,
  EventEmitter,
  Output,
  OnInit,
  ElementRef,
  Inject,
  ViewChild
} from '@angular/core';
import { DropdownComponent } from '@iv/shared/components/dropdown/dropdown.component';
import {
  screenersViewModel,
  termsViewModel,
  tradeDatePeriodsViewModel,
  periodsViewModel,
  TradeDatePeriodsView,
  PeriodsView,
  TermsView
} from './model/screeners';
import * as TabsActions from '@iv/store/tabs/tabs.actions';
import { AppStore } from '@iv/store/app.store';
import * as Redux from 'redux';
import { AppState } from '@iv/store/app.reducer';
import { getCurrentTab } from '@iv/store/tabs/tabs.selectors';

@Component({
  selector: 'iv-live-screeners-dropdown',
  templateUrl: './screeners-dropdown.component.html',
  styleUrls: ['./screeners-dropdown.component.scss']
})
export class ScreenersDropdownComponent extends DropdownComponent implements OnInit {
  public screenersViewModel = screenersViewModel;
  public termsViewModel = termsViewModel;
  public tradeDatePeriodsViewModel = tradeDatePeriodsViewModel;
  public periodsViewModel = periodsViewModel;

  public showScreenersDropdown = false;
  public showTermsDropdown = false;
  public showTradeDatePeriodsDropdown = false;
  public showPeriodsDropdown = false;

  public configureScreenerPopupVisible = false;
  public screenerDescriptionPopup = false;

  public screenerType: string;
  public screenerTypeName: string;
  public screenerName: string;
  public screenerValue = '';
  public screenerDescription: string;

  public termName = '';
  public termType: string;

  public tradeDatePeriodName = '';
  public tradeDatePeriod: number;

  public periodName = '';
  public period: number;

  public percent: number;

  public termFieldCheck = false;
  public tradeDatePeriodFieldCheck = false;
  public periodFieldCheck = false;
  public percentFieldCheck = false;

  @Output() apply = new EventEmitter();
  @Output() screenerColumns = new EventEmitter<string[]>();

  @ViewChild('popupContainer') popupRef: ElementRef;

  constructor(
    protected _eref: ElementRef,
    @Inject(AppStore) private store: Redux.Store<AppState>
  ) {
    super(_eref);
  }

  ngOnChanges(): void {
    this.setInputValuesFromStore()
  }

  ngOnInit() {
    this.setInputValuesFromStore()
    this.fillInputValues()
  }

  cleanFields() {
    const percentField = document.querySelector('.percent-textfield') as HTMLInputElement;

    if (percentField) {
      this.removeTooltip(percentField);
    }

    this.termName = '';
    this.tradeDatePeriodName = '';
    this.periodName = '';

    this.termFieldCheck = false;
    this.tradeDatePeriodFieldCheck = false;

    this.periodFieldCheck = false;

    this.setInputValuesFromStore()
    this.fillInputValues()
  }

  private _updateTabData(name, value) {
    this.store.dispatch(TabsActions.updateTabData({
      name: name,
      value: value
    }));
  }

  onPopupCancel(popupVisible) {
    this.cleanFields();
    this.applyBtnCheck();
    this[popupVisible] = false;
    let timeout = setTimeout(() => {
      this.showDropdown = false;
      timeout = null;
    }, 1);
  }

  toggleTermsDropdown() {
    this.showTermsDropdown = !this.showTermsDropdown;
    this.showTradeDatePeriodsDropdown = false;
  }

  toggleTradeDatePeriodsDropdown() {
    this.showTradeDatePeriodsDropdown = !this.showTradeDatePeriodsDropdown;
  }

  togglePeriodsDropdown() {
    this.showPeriodsDropdown = !this.showPeriodsDropdown;
  }

  onScreenersItemClick(screener) {
    this.showTermsDropdown = false;
    this.showTradeDatePeriodsDropdown = false;
    this.showPeriodsDropdown = false;

    this.showDropdown = !this.showDropdown;
    this.screenerTypeName = screener.screenerType;
    this.screenerDescription = screener.description;
    this.screenerName = screener.name;

    if (this.screenerTypeName !== 'HIGHEST_CALL_TO_PUT_RATIO' && this.screenerTypeName !== 'HIGHEST_PUT_TO_CALL_RATIO' && this.screenerTypeName !== 'ALL_INSTRUMENTS') {
      this.configureScreenerPopupVisible = !this.configureScreenerPopupVisible;
    }

    if (this.screenerTypeName === 'HIGHEST_CALL_TO_PUT_RATIO') {
      this.screenerType = screener.screenerType;
      this._updateTabData('screenerType', this.screenerType);
      this.screenerColumns.emit(['callputvolumeratio', 'callputvolumeratio_eod']);
      this.screenerValue = this.screenerName;
      this.apply.emit();
    }

    if (this.screenerTypeName === 'HIGHEST_PUT_TO_CALL_RATIO') {
      this.screenerType = screener.screenerType;
      this._updateTabData('screenerType', this.screenerType);
      this.screenerColumns.emit(['putcallvolumeratio', 'putcallvolumeratio_eod']);
      this.screenerValue = this.screenerName;
      this.apply.emit();
    }

    if (this.screenerTypeName === 'ALL_INSTRUMENTS') {
      this.dropScreener();
      this.apply.emit();
    }

    this.applyBtnCheck();

    setTimeout(() => {
      if(this.popupRef && this.applyBtnCheck()) {
        this.popupRef.nativeElement.focus();
      }
    },500)
  }

  dropScreener() {
    this.screenerValue = 'All instruments';
    this.screenerType = undefined;
    this.updateTabData();
  }

  onTermsItemClick(term) {
    this.showTermsDropdown = !this.showTermsDropdown;
    this.termName = term.name;
    this.termType = term.termType;
    this.termFieldCheck = true;
    this.applyBtnCheck();
  }

  onTradeDatePeriodsItemClick(tradeDatePeriod) {
    this.showTradeDatePeriodsDropdown = !this.showTradeDatePeriodsDropdown;
    this.tradeDatePeriodName = tradeDatePeriod.name;
    this.tradeDatePeriod = tradeDatePeriod.tradeDatePeriod;
    this.tradeDatePeriodFieldCheck = true;
    this.applyBtnCheck();
  }

  onPeriodItemClick(period) {
    this.showPeriodsDropdown = !this.showPeriodsDropdown;
    this.periodName = period.name;
    this.period = period.period;
    this.periodFieldCheck = true;
    this.applyBtnCheck();
  }

  updateTabData() {
    this._updateTabData('screenerType', this.screenerType);
    this._updateTabData('termType', this.termType);
    this._updateTabData('tradeDatePeriod', this.tradeDatePeriod);
    this._updateTabData('period', this.period);
    this._updateTabData('percent', this.percent);
  }

  onPopupApply() {
    this.screenerType = this.screenerTypeName;
    this.screenerValue = this.screenerName;
    this.configureScreenerPopupVisible = false;
    this.showTermsDropdown = false;
    this.showTradeDatePeriodsDropdown = false;
    this.showPeriodsDropdown = false;
    this.updateTabData();
    this.apply.emit();
  }

  percentInput($event) {
    const input = $event.srcElement;
    const inputValue = parseFloat(input.value);

    input.value = input.value.replace(/\-{2,}/g, '-').replace(/[^0-9\-]|\b-/g, '');

    if (inputValue < -100 || inputValue > 1000) {
      this.removeTooltip(input);
      input.style.borderColor = 'red';
      this.percentInputTooltip(input);
      this.percentFieldCheck = false;
    } else {
      this.removeTooltip(input);
      this.percentFieldCheck = true;
    }

    if (this.percent === null || (inputValue < -100 || inputValue > 1000 || input.value === '-' || input.value === '-0') || input.value === '') this.percentFieldCheck = false;
    else this.percentFieldCheck = true;

    this.applyBtnCheck();
  }

  applyBtnCheck() {
    if ((this.screenerTypeName === 'BREAKING_OUT_IVS' || this.screenerTypeName === 'COLLAPSING_IVS') && this.termFieldCheck && this.tradeDatePeriodFieldCheck && this.percentFieldCheck) {
      return true;
    } else if ((this.screenerTypeName === 'HIGH_CALL_VOLUME' || this.screenerTypeName === 'HIGH_PUT_VOLUME') && this.periodFieldCheck) {
      return true;
    } else return false;
  }

  removeTooltip(input) {
    if (input && input.classList.contains('percent-textfield') && input.nextSibling) {
      input.nextSibling.remove();
      input.style.borderColor = '';
    }
  }

  percentInputTooltip(elem) {
    const param = elem.parentNode;
    param.style.position = 'relative';
    const tooltip = document.createElement('div');
    const tooltipFigure = document.createElement('div');
    const tooltipContent = document.createElement('div');

    tooltip.classList.add('percent-input-tooltip');

    tooltip.style.cssText = `
      position: absolute;
      left: 100%;
      display: flex;
      z-index: 9999;
      height: 23px;
      top: 4px;
    `;

    tooltipFigure.style.cssText = `
      border-right: 7px solid rgba(245, 97, 112, 0.8);
      border-top: 7px solid transparent;
      border-bottom: 7px solid transparent;
      height: 10px;
      margin-top: 5px;
    `;

    tooltipContent.style.cssText = `
      background: rgba(245, 97, 112, 0.8);
      font-weight: 400;
      font-size: 12px;
      color: #fff;
      border-radius: 4px;
      line-height: 23px;
      padding: 0 10px;
      white-space: nowrap;
    `;

    tooltipContent.innerText = 'Please, enter a value between -100 and 1000';

    tooltip.appendChild(tooltipFigure);
    tooltip.appendChild(tooltipContent);
    param.appendChild(tooltip);
  }

  private fillInputValues():void {

    this.tradeDatePeriodName = this.findTradeDateNameByNumber(this.tradeDatePeriod)
    if (this.tradeDatePeriodName) {
      this.tradeDatePeriodFieldCheck = true;
    } else {
      this.tradeDatePeriodName = "";
    }

    this.periodName = this.findPeriodNameByNumber(this.period);
    if (this.periodName) {
      this.periodFieldCheck = true;
    } else {
      this.periodName = "";
    }

    this.termName = this.findTermNameByType(this.termType);
    if (this.termName) {
      this.termFieldCheck = true;
    } else {
      this.termName = "";
    }

    if (this.percent) {
      this.percentFieldCheck = true;
    } else {
      this.percent = null
    }
  }

  private setInputValuesFromStore(): void {
    const currentTab = getCurrentTab(this.store.getState());
    if (!this.screenerType && currentTab.data?.screenerType) {
      this.screenerValue = this.screenersViewModel.find(value => value.screenerType === currentTab.data.screenerType).name;
      this.apply.emit();
    }

    this.screenerType = currentTab.data.screenerType;
    this.termType = currentTab.data.termType;
    this.tradeDatePeriod = currentTab.data.tradeDatePeriod;
    this.period = currentTab.data.period;
    this.percent = currentTab.data.percent;
  }

  private findTradeDateNameByNumber(quantity: number): string {
    const tradeDate = this.tradeDatePeriodsViewModel.find((item: TradeDatePeriodsView) => item.tradeDatePeriod === quantity)
    return tradeDate?.name
  }

  private findPeriodNameByNumber(quantity: number): string {
    const period = this.periodsViewModel.find((item: PeriodsView) => item.period === quantity)
    return period?.name
  }

  private findTermNameByType(type: string): string {
    const term = this.termsViewModel.find((item: TermsView) => item.termType === type)
    return term?.name
  }
}
